export class RestApi {
  constructor(public method: string, public url: string) {}
}
